import { createRouter, createWebHashHistory } from "vue-router";
import Download from "@/view/download/DownloadView.vue";
import AppStore from "@/view/app-store/AppStoreView.vue";

const routes = [
  { path: "/", name: "", component: Download },
  { path: "/home", name: "Home", component: Download },
  { path: "/app-store", name: "AppStore", component: AppStore },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
